import * as angular from 'angular';
import { goModalBootstrapModule } from '../modals/go-modal-bootstrap.factory';
import { UserNotificationHandler } from './user-notifications.service';

export const userNotificationsModule = angular.module('user-notifications', [
	goModalBootstrapModule
])
	.service('userNotificationHandler', UserNotificationHandler)
	.name;
